<template>
    <div class="container">
           <el-table
                :data="tableData"
                border
            >
                <el-table-column
                    v-for="col in tableCols"
                    :key="col.prop"
                    :prop="col.prop"
                    :label="col.label"
                    :width="col.width"
                    :align="col.align">
                        <template #default="scope">
                            <div v-if="(scope.column.property==='Operation')">
                                 <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-edit"
                                @click="showFlowChoose(scope.row.Name)">生成</el-button>
                            </div>
                            <div v-else>
                                {{scope.row[scope.column.property]}}
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
        <el-dialog title="选择流程" v-model="flowVisible" width="60%" top="7vh">
            <el-form ref="detailForm" label-width="110px" :inline="true">
                <el-form-item label="关键字：">
                    <el-input
                        v-model="flowQuery.keyword"
                        size="small"
                        style="width: 220px;"
                        placeholder="请输入申请人"
                    ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-button  size="small" type="primary"  @click="getFlowList">查询</el-button>
                </el-form-item>
            </el-form>
          <el-table
            :data="flowList"
            border
            :max-height="600">
            <el-table-column
              v-for="col in flowCols"
              :key="col.prop"
              :prop="col.prop"
              :label="col.label"
              :width="col.width"
              :align="col.align">
              <template #default="scope">
                <div v-if="(scope.column.property==='State')">
                  <span v-if="(scope.row.State==5)">已完成</span>
                  <span v-else-if="(scope.row.State==4)">
                    <span style="color:red" v-if="(scope.row.RefuseType==1)">
                        银行经理拒绝
                    </span>
                    <span style="color:red" v-if="(scope.row.RefuseType==2)">
                        银行部长拒绝
                    </span>
                    <span style="color:red" v-if="(scope.row.RefuseType==3)">
                        担保经理拒绝
                    </span>
                    <span style="color:red" v-if="(scope.row.RefuseType==4)">
                        担保部长拒绝
                    </span>
                    <span style="color:red" v-if="(scope.row.RefuseType==5)">
                        长时间未缴费被拒绝
                    </span>
                  </span>
                  <span v-else-if="(scope.row.State==3)">用户已撤销</span>
                  <span v-else-if="(scope.row.State==2)">
                                   <span v-if="(scope.row.RecallType==1)">被风控退回</span>
                                   <span v-else>被担保经理退回</span>
                               </span>
                  <span v-else-if="(scope.row.State==1)">
                                   <div v-if="(scope.row.Type===1)">
                                       <span v-if="(scope.row.Route==1)">分配担保经理</span>
                                       <span v-if="(scope.row.Route==5)">担保审核</span>
                                       <span v-if="(scope.row.Route==6)">确认担保金额</span>
                                       <span v-if="(scope.row.Route==7)">风控审核</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)>0)">用户缴费</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)===0)">出具担保函</span>
                                       <span v-if="(scope.row.Route==9)">确认收款</span>
                                       <span v-if="(scope.row.Route==10)">出具担保函</span>
                                       <span v-if="(scope.row.Route==11)">分管风控领导确认</span>
                                       <span v-if="(scope.row.Route==12)">分管业务领导确认</span>
                                   </div>
                                   <div v-if="(scope.row.Type===2)">
                                       <span v-if="(scope.row.Route==1)">分配银行经理</span>
                                        <span v-if="(scope.row.Route==2)">银行审核</span>
                                        <span v-if="(scope.row.Route==3)">银行部长审核</span>
                                        <span v-if="(scope.row.Route==4)">分配担保经理</span>
                                       <span v-if="(scope.row.Route==5)">担保审核</span>
                                       <span v-if="(scope.row.Route==6)">确认担保金额</span>
                                       <span v-if="(scope.row.Route==7)">风控审核</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)>0)">用户缴费</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)===0)">出具担保函</span>
                                       <span v-if="(scope.row.Route==9)">确认收款</span>
                                       <span v-if="(scope.row.Route==10)">出具担保函</span>
                                       <span v-if="(scope.row.Route==11)">分管风控领导确认</span>
                                       <span v-if="(scope.row.Route==12)">分管业务领导确认</span>
                                   </div>
                                   <div v-if="(scope.row.Type===3)">
                                       <span v-if="(scope.row.Route==1)">银行审核</span>
                                       <span v-if="(scope.row.Route==3)">银行部长审核</span>
                                        <span v-if="(scope.row.Route==4)">分配担保经理</span>
                                       <span v-if="(scope.row.Route==5)">担保审核</span>
                                       <span v-if="(scope.row.Route==6)">确认担保金额</span>
                                       <span v-if="(scope.row.Route==7)">风控审核</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)>0)">用户缴费</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)===0)">出具担保函</span>
                                       <span v-if="(scope.row.Route==9)">确认收款</span>
                                       <span v-if="(scope.row.Route==10)">出具担保函</span>
                                       <span v-if="(scope.row.Route==11)">分管风控领导确认</span>
                                       <span v-if="(scope.row.Route==12)">分管业务领导确认</span>
                                   </div>
                                   <div v-if="(scope.row.Type===4)">
                                       <span v-if="(scope.row.Route==1)">担保审核</span>
                                       <span v-if="(scope.row.Route==6)">确认担保金额</span>
                                       <span v-if="(scope.row.Route==7)">风控审核</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)>0)">确认收款</span>
                                       <span v-if="(scope.row.Route==8&&Number(scope.row.GuaranteeFee)===0)">出具担保函</span>
                                       <span v-if="(scope.row.Route==10)">出具担保函</span>
                                       <span v-if="(scope.row.Route==11)">分管风控领导确认</span>
                                       <span v-if="(scope.row.Route==12)">分管业务领导确认</span>
                                   </div>
                               </span>
                </div>
                <div v-else-if="(scope.column.property==='Operation')">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="chooseFlow(scope.row)">选择</el-button>
                </div>
                <div v-else>
                  {{scope.row[scope.column.property]}}
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination">
            <el-pagination
              background
              @size-change="handleFlowSizeChange"
              @current-change="handleFlowPageChange"
              :current-page="flowQuery.pageIndex"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="flowQuery.pageSize"
              layout="total, sizes, prev, pager, next"
              :total="flowPageTotal">
            </el-pagination>
          </div>
        </el-dialog>

    </div>

    <WordTemp ref="wordTemp"></WordTemp>

</template>

<script>
import indexJs from "./index.js";
  export default indexJs;
</script>

<style scoped>
.dialog-Btn{
    text-align: center;
}
.FileLink{
    color: red;
    cursor: pointer;
    margin-right: 40px;
}
</style>
